// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Gt2VideoBand_wrap__5PjQb","video":"Gt2VideoBand_video__B3aP_"};